import { getCookieValue } from "@moodys/mdc-toolbox.user.utils";

import { FALLBACK_LANGUAGE_NODES, MenuNodeType } from "components/Menu/model";

import { setCookie } from "../documentCookie";
import { getFirstPathnameSegment } from "../url";

import {
  Language,
  LANGUAGE_CONFIG,
  LANGUAGE_MAPPING,
} from "./language.constants";

export const isValidLanguage = (language: string): language is Language => {
  return Object.values(Language).includes(language as Language);
};

export const getLanguageFromCookie = () => {
  const cookie = getCookieValue(LANGUAGE_CONFIG.COOKIE_NAME);

  if (cookie && isValidLanguage(cookie)) {
    return cookie;
  }

  return Language.ENGLISH;
};

export const getLanguageFromCurrentUrl = (
  languageNodes: MenuNodeType.Link[]
) => {
  const pathname = location.pathname.toLowerCase();
  const pathnameFirstSegment = getFirstPathnameSegment(pathname);
  const queryParams = new URLSearchParams(location.search);
  const langQueryParam = queryParams.get(LANGUAGE_CONFIG.LANGUAGE_QUERY_PARAM);

  if (
    pathnameFirstSegment === Language.CHINESE ||
    langQueryParam === Language.CHINESE
  ) {
    return Language.CHINESE;
  }

  if (
    pathnameFirstSegment === Language.JAPANESE ||
    langQueryParam === Language.JAPANESE ||
    languageNodes.find(
      (node) =>
        node.titleKey.includes(
          LANGUAGE_MAPPING[Language.JAPANESE].menuLanguagePreferenceText
        ) && pathname == node.href.toLowerCase()
    )
  ) {
    return Language.JAPANESE;
  }

  return Language.ENGLISH;
};

export const getLanguageFromMenuText = (menuText: string) => {
  return (
    (Object.keys(LANGUAGE_MAPPING) as Language[]).find((language) =>
      menuText
        .toLowerCase()
        .includes(
          LANGUAGE_MAPPING[language].menuLanguagePreferenceText.toLowerCase()
        )
    ) ?? Language.ENGLISH
  );
};

export const getPageLanguage = (languageNodes?: MenuNodeType.Link[]) => {
  const urlLanguage = getLanguageFromCurrentUrl(
    languageNodes ?? FALLBACK_LANGUAGE_NODES
  );
  const cookieLanguage = getLanguageFromCookie();

  if (urlLanguage !== Language.ENGLISH) {
    return urlLanguage;
  }

  return cookieLanguage;
};

export const getHomepageLinkForLanguage = (
  languageNodes?: MenuNodeType.Link[],
  setLanguage?: Language
) => {
  const language = setLanguage ?? getLanguageFromCookie();
  return (
    (languageNodes ?? FALLBACK_LANGUAGE_NODES).find((node) =>
      node.titleKey.includes(
        LANGUAGE_MAPPING[language].menuLanguagePreferenceText
      )
    )?.href ?? "/"
  );
};

export const setLanguageCookie = (language: string) =>
  setCookie({
    cookieName: LANGUAGE_CONFIG.COOKIE_NAME,
    cookieValue: language,
  });
